import {
  IInitializeAction,
  INITIALIZE,
  ASYNC_START,
  ASYNC_FINISH,
  IAsyncErrordAction,
  ASYNC_ERROR,
  IAsyncStartAction,
  IAsyncFinishAction,
  message,
  IClearStateAction,
  CLEAR_STATE,
} from './types'

export const initialize = (): IInitializeAction => ({
  type: INITIALIZE,
})

export const asyncStart = (message?: message): IAsyncStartAction => ({
  type: ASYNC_START,
  message,
})

export const asyncFinish = (message?: message): IAsyncFinishAction => ({
  type: ASYNC_FINISH,
  message,
})

export const asyncError = (error: string): IAsyncErrordAction => ({
  type: ASYNC_ERROR,
  error,
})

export const clearState = (): IClearStateAction => ({
  type: CLEAR_STATE,
})
